/**
 * @generated SignedSource<<b3e5213ebe1f1fd0c17bb95258ba5cce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WorkspaceRunnerPhase = "BINDING_VOLUME" | "PENDING" | "PREPARING_WORKSPACE" | "READY" | "SCHEDULING_POD" | "STARTING_POD";
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceViewerFragment$data = {
  readonly id: string;
  readonly phase: WorkspaceRunnerPhase;
  readonly url: Url;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspacePhaseProgressFragment">;
  readonly " $fragmentType": "WorkspaceViewerFragment";
};
export type WorkspaceViewerFragment$key = {
  readonly " $data"?: WorkspaceViewerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceViewerFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceViewerFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspacePhaseProgressFragment"
    }
  ],
  "type": "WorkspaceRunner",
  "abstractKey": null
};

(node as any).hash = "be2be0648e5a3f39012df9c0239dcef1";

export default node;
